import React from 'react';
import {BaseSettingsForm} from '@/components/forms';
import {Form, Row, Col} from 'react-bootstrap';
import {useStoreState} from 'easy-peasy';
import * as yup from 'yup';
import i18n from 'i18n';

interface AudioAnonymizationTask {
    id: number;
    taskId: string;
    status: string;
    eventCallId: number | null;
    type: string;
}

interface AudioAnonymizationTasksSettingsFormProps {
    audioAnonymizationTaskId: number;
}

interface FormValues {
    taskId: string;
    status: string;
    eventCallId: number | null;
    type: string;
}

const AudioAnonymizationTasksSettingsForm: React.FC<AudioAnonymizationTasksSettingsFormProps> = React.memo((
    {
        audioAnonymizationTaskId = 0,
    },
) => {
    const audioAnonymizationTasks = useStoreState<{ audioAnonymizationTasks: { items: AudioAnonymizationTask[] } }>((state) => state.audioAnonymizationTasks.items);
    const selectedAudioAnonymizationTask = audioAnonymizationTasks.find((audioAnonymizationTask: AudioAnonymizationTask) => audioAnonymizationTask.id === audioAnonymizationTaskId);

    const initialValues: FormValues = selectedAudioAnonymizationTask || {
        taskId: '',
        status: '',
        eventCallId: null,
        type: '',
    };

    // Read-only form - no actual CRUD operations
    const customSubmissionHandler = async () => {
        // No-op for read-only form
        return {data: initialValues};
    };

    const validationSchema = yup.object({
        taskId: yup.string(),
        status: yup.string(),
        eventCallId: yup.number().nullable(),
        type: yup.string(),
    });

    return (
        <BaseSettingsForm
            entityId={audioAnonymizationTaskId}
            resourceUrl="" // Not used with customSubmissionHandler
            storeActionPath="" // Not used with customSubmissionHandler
            validationSchema={validationSchema}
            initialValues={initialValues}
            successMessageKey=""
            customSubmissionHandler={customSubmissionHandler}
        >
            {(formik, loading) => (
                <>
                    <Row>
                        <Col xs={12}>
                            <Form.Group className="mb-3" controlId="externalTaskId" >
                                <Form.Label>{i18n.t('jt_task.text')}</Form.Label>
                                <Form.Control
                                    name="taskId"
                                    value={formik.values.taskId}
                                    disabled
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12}>
                            <Form.Group className="mb-3" controlId="status" >
                                <Form.Label>{i18n.t('jt_task_status.text')}</Form.Label>
                                <Form.Control
                                    name="status"
                                    value={formik.values.status}
                                    disabled
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12}>
                            <Form.Group className="mb-3" controlId="eventCallId" >
                                <Form.Label>{i18n.t('jt_event_call.text')}</Form.Label>
                                <Form.Control
                                    name="eventCallId"
                                    value={formik.values.eventCallId || ''}
                                    disabled
                                />
                            </Form.Group>
                        </Col>
                    </Row >
                </>
            )}
        </BaseSettingsForm >
    );
});


export default AudioAnonymizationTasksSettingsForm; 